import axios from 'axios';
import type {
  RegistrationResultDto,
  RegistrationResultModel,
} from '@hotjar/webapp/domains/acquisition/register/dto';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import type { AcceptInvite } from '@hotjar/webapp/domains/invitations/model';

import { acceptInviteDtoToModel, acceptInviteModelToDto, invitationDtoToModel } from '../mapper';
import type { InvitationModelResponse } from '../dto';

export async function getInvitationByToken(token: string): Promise<InvitationModelResponse> {
  const response = await axios.get(`/api/v1/invitations/${token}`);
  return invitationDtoToModel(response.data);
}

export async function acceptInvite(
  acceptInviteData: AcceptInvite,
): Promise<RegistrationResultModel> {
  const response = await axios.post<ApiBaseResponse & RegistrationResultDto>(
    '/api/v1/registration/accept-invite',
    acceptInviteModelToDto(acceptInviteData),
  );

  if (!response.data.success) throw new Error('Failed to invite user');

  return acceptInviteDtoToModel(response.data);
}
